"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create default CRUD actions for collection
 *
 * export const emails = create('email');
 * export const phones = Object.assign(create('phone'), {
 *	// add additional action to 'phone' collection
 *	hide: function (id) {
 *		return {
 *			type: 'HIDE_PHONE',
 *			data: id
 *		};
 *	}
 *});
 *
 * then on the page
 *
 * import { emails } from './actions/collection';
 * dispatch(emails.add(email));
 * dispatch(emails.update(email));
 * dispatch(emails.remove(id));
 * dispatch(emails.select(id));
 *
 * @param elementName
 * @returns {{actionTypes: {ADD: string, UPDATE: string, REMOVE: string, SELECT: string}, add: add, update: update, remove: remove, select: select}}
 */
function create(elementName) {
    if (!elementName) {
        throw new Error('You need element name to create a collection');
    }
    var name = elementName.toUpperCase();
    var ADD = 'ADD_' + name;
    var UPDATE = 'UPDATE_' + name;
    var REMOVE = 'REMOVE_' + name;
    var SELECT = 'SELECT_' + name;
    function add(payload) {
        return {
            type: ADD,
            data: payload
        };
    }
    function update(payload) {
        return {
            type: UPDATE,
            data: payload
        };
    }
    function remove(id) {
        return {
            type: REMOVE,
            data: id
        };
    }
    function select(id) {
        return {
            type: SELECT,
            data: id
        };
    }
    return {
        actionTypes: {
            ADD: ADD,
            UPDATE: UPDATE,
            REMOVE: REMOVE,
            SELECT: SELECT
        },
        add: add,
        update: update,
        remove: remove,
        select: select
    };
}
exports.create = create;
